import $ from "jquery";
import disableMaterial from "../2-material/disableMaterial";
import enableMaterial from "../2-material/enableMaterial";
import {
	BOTTOM_LETTERS_INPUT,
	BOTTOM_LETTERS_WRAPPER_SELECTOR,
	KNIT_BEANIE_TEXT,
	MICRO_BEANIE_TEXT,
	MICRO_CHECKBOX,
	OUTLINE_WRAPPER_SELECTOR,
	SCRIPT_TEXT,
	SECONDARY_LETTERS,
	SECONDARY_LETTERS_WRAPPER_SELECTOR,
} from "../4-one-of-one/_selectors";
import { KNIT_BEANIE_INPUT, MICRO_BEANIE_INPUT, OUTLINE_INPUT, SCRIPT_TEXT_NOT_SELECT } from "../constants/selectors";
import enableInput from "../dom/enableInput";
import { getStyleNameFromAttribute } from "../dom/getStyleNameFromAttribute";
import resetInputValue from "../dom/resetInputValue";
import selectAllElements from "../dom/selectAllElements";
import selectSingleElement from "../dom/selectSingleElement";
import { showOrHideElements } from "../dom/showOrHideElements";
import type { Materials } from "./chooseStyleSetup";
import type { HatStyles } from "./hatStyles";

export default function chooseStyleSpansHandleClick(
	span: HTMLSpanElement,
	materials: Materials,
	materialSpans: NodeListOf<HTMLElement>,
	hatStyles: HatStyles,
) {
	const style = getStyleNameFromAttribute(span);
	const styles = Object.keys(hatStyles);

	if (style !== null) {
		console.log("Selected style:", style);

		// Handle input field visibility based on style selection
		if (style === "knitBeanies") {
			// Check if micro checkbox is checked to determine which beanie input to show
			const microCheckbox = selectSingleElement<HTMLInputElement>(MICRO_CHECKBOX);
			
			if (microCheckbox?.checked) {
				// Show micro beanie input, hide regular beanie input
				showOrHideElements({
					elements: selectAllElements<HTMLDivElement>(MICRO_BEANIE_TEXT),
					show: true,
				});
				showOrHideElements({
					elements: selectAllElements<HTMLDivElement>(KNIT_BEANIE_TEXT),
					show: false,
				});
			} else {
				// Show regular beanie input, hide micro beanie input
				showOrHideElements({
					elements: selectAllElements<HTMLDivElement>(KNIT_BEANIE_TEXT),
					show: true,
				});
				showOrHideElements({
					elements: selectSingleElement(MICRO_BEANIE_TEXT),
					show: false,
				});
			}
			
			// Hide regular script inputs and outline
			showOrHideElements({
				elements: [
					...selectAllElements(SCRIPT_TEXT),
					selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
				],
				show: false,
			});
			
			// Clear regular script input and top/bottom letters when switching to beanie style
			resetInputValue(selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_NOT_SELECT));
			resetInputValue(selectSingleElement<HTMLInputElement>(SECONDARY_LETTERS));
			resetInputValue(selectSingleElement<HTMLInputElement>(BOTTOM_LETTERS_INPUT));
		} else {
			// Show regular inputs, hide beanie inputs
			showOrHideElements({
				elements: selectAllElements<HTMLDivElement>(KNIT_BEANIE_TEXT),
				show: false,
			});
			
			// Check if micro checkbox is checked and uncheck it when leaving beanie style
			const microCheckbox = selectSingleElement<HTMLInputElement>(MICRO_CHECKBOX);
			if (microCheckbox?.checked) {
				microCheckbox.checked = false;
				// Trigger change event to reset micro state
				microCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
			}
			
			showOrHideElements({
				elements: [
					...selectAllElements(SCRIPT_TEXT),
					selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
				],
				show: true,
			});
			// Hide micro beanie text when switching to non-beanie styles
			showOrHideElements({
				elements: selectSingleElement(MICRO_BEANIE_TEXT),
				show: false,
			});

			// Clear the beanie inputs when switching away from beanie style
			resetInputValue(selectSingleElement<HTMLInputElement>(KNIT_BEANIE_INPUT));
			resetInputValue(selectSingleElement<HTMLInputElement>(MICRO_BEANIE_INPUT));

			// Re-enable script input that might have been disabled by micro
			const scriptInput = selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_NOT_SELECT);
			if (scriptInput) {
				scriptInput.disabled = false;
				scriptInput.style.opacity = '1';
			}

			// Re-enable inputs that were disabled in beanie mode
			enableInput(
				selectSingleElement<HTMLInputElement>(SECONDARY_LETTERS),
				selectSingleElement<HTMLDivElement>(SECONDARY_LETTERS_WRAPPER_SELECTOR),
			);
			enableInput(
				selectSingleElement<HTMLInputElement>(BOTTOM_LETTERS_INPUT),
				selectSingleElement<HTMLDivElement>(BOTTOM_LETTERS_WRAPPER_SELECTOR),
			);
		}

		// First, disable ALL materials from ALL styles
		for (const currentStyle of styles) {
			const currentStyleMaterials = materials[currentStyle as string];
			console.log(`Disabling materials for ${currentStyle}:`, currentStyleMaterials);
			disableMaterial(currentStyleMaterials, materialSpans);
		}

		// Then, enable only the materials for the selected style
		const styleMaterials = materials[style as string];
		console.log(`Enabling materials for ${style}:`, styleMaterials);
		enableMaterial(styleMaterials, materialSpans);

		// Trigger click on first material for this style if it exists
		if (styleMaterials && styleMaterials.length > 0) {
			console.log(`Triggering click on first material: ${styleMaterials[0]}`);
			$(`.pplr-choose-material .pplr-drop-item[data-value="${styleMaterials[0]}"]`).trigger(
				"click",
			);
		}
	}
}
